export default __webpack_public_path__ + "static/media/1459.98ea8eeb.png";